import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { lastValueFrom } from "rxjs";

const debug = true;

@Injectable({ providedIn: "root" })
export class SignUpHubspotService {
  private httpClient = inject(HttpClient);

  hubspotInitRequest(params: Record<string, string>): void {
    const formId = "4e6cc6b2-b1c2-4d96-9359-bcc9af7a308e",
      hsContext: any = {
        pageUrl:
          window.location.protocol +
          "//" +
          window.location.host +
          location.pathname.substring(0, location.pathname.lastIndexOf("/")),
        hutk: (document.cookie.match(/^(?:.*;)?hubspotutk=([^;]+)(?:.*)?$/) || [
          undefined,
          undefined
        ])[1]
      };
    let httpParams: HttpParams = new HttpParams();

    httpParams = httpParams.set("encoding", "UTF-8");
    httpParams = httpParams.set("email", params.email);
    httpParams = httpParams.set("hs_context", JSON.stringify(hsContext));
    httpParams = httpParams.set("company", params.company);
    if (params.numemployees.length > 0) {
      httpParams = httpParams.set("numemployees", params.numemployees);
    }
    if (params.leadsource.length > 0) {
      httpParams = httpParams.set("leadsource", params.leadsource);
    }
    if (params.lead_type.length > 0) {
      httpParams = httpParams.set("lead_type", params.lead_type);
    }
    if (params.contact_phone.length > 0) {
      httpParams = httpParams.set("phone", params.contact_phone);
    }
    if (params.name.length > 0) {
      const index = params.name.indexOf(" ");
      if (index === -1) {
        httpParams = httpParams.set("firstname", params.name);
      } else {
        httpParams = httpParams.set("firstname", params.name.substring(0, index));
        httpParams = httpParams.set("lastname", params.name.substring(index + 1));
      }
    }

    debug &&
      console.warn("Hubspot email form: ", "formId: ", formId, " params: ", params, httpParams);

    lastValueFrom(
      this.httpClient.post(
        "https://forms.hubspot.com/uploads/form/v2/516769/" + formId,
        {},
        {
          params: httpParams,
          headers: new HttpHeaders({
            Accept: "application/json, txt/plain, */*",
            "Content-Type": "application/x-www-form-urlencoded"
          }),
          observe: "response"
        }
      )
    )
      .then((response: any) => {
        if (!response || response.status !== 200) {
          console.error("hubspot confirmation error:", response.data && response.data.error);
        }
      })
      .catch(() => {});
  }

  postAccountCreateHubspotRequest(params: Record<string, string> = {}): void {
    // constant for confirmation
    const formId = "81b9080d-2ae6-4426-a5c0-e68dc5485ce7",
      hsContext: any = {
        pageUrl:
          window.location.protocol +
          "//" +
          window.location.host +
          location.pathname.substring(0, location.pathname.lastIndexOf("/")),
        hutk: (document.cookie.match(/^(?:.*;)?hubspotutk=([^;]+)(?:.*)?$/) || [
          undefined,
          undefined
        ])[1]
      };
    let httpParams: HttpParams = new HttpParams();

    httpParams = httpParams.set("encoding", "UTF-8");
    httpParams = httpParams.set("email", params.email);
    httpParams = httpParams.set("sip_address", params.sip_address);
    httpParams = httpParams.set("team_create_account_id", params.team_create_account_id);
    httpParams = httpParams.set("team_create_account_created", params.team_create_account_created);
    httpParams = httpParams.set("team_create_username", params.team_create_username);
    httpParams = httpParams.set("team_create_subdomain", params.team_create_subdomain);
    httpParams = httpParams.set("company", params.company);
    if (params.website) {
      httpParams = httpParams.set("website", params.website);
    }
    httpParams = httpParams.set("jobtitle", params.jobtitle);
    httpParams = httpParams.set("hs_context", JSON.stringify(hsContext));

    debug &&
      console.warn("Hubspot signup form: ", "formId: ", formId, " params: ", params, httpParams);

    lastValueFrom(
      this.httpClient.post(
        "https://forms.hubspot.com/uploads/form/v2/516769/" + formId,
        {},
        {
          params: httpParams,
          headers: new HttpHeaders({
            Accept: "application/json, txt/plain, */*",
            "Content-Type": "application/x-www-form-urlencoded"
          }),
          observe: "response"
        }
      )
    )
      .then((response: any) => {
        if (!response || response.status !== 200) {
          console.error("hubspot confirmation error:", response.data && response.data.error);
        }
      })
      .catch(() => {});
  }
}
